export { LoginPaypalService } from './services/login-paypal.service';
export { AuthGuardService } from './services/auth-guard.service';
export { LoginService } from './services/login.service';
export { TemaService } from './services/tema.service';
export { HttpService } from './services/http.service';
export { PermisosService } from './services/permisos.service';
export { LoadingService } from './services/loading.service';